import React from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from "../../../components/general/general-component/abstruct-component/AbstructVar";
import { AbstructLang } from "../../../components/general/general-component/abstruct-component/AbstructLang";
import {exportExpenses} from "../../../store/Actions/ActionExpenses";
import { VariableExpenses } from "./VariableExpenses";

function ExportExpenses({open,setOpen,statement_id}) 
{
  let { mode, dispatch } = AbstructVar();

  const { translate } = AbstructLang();

  const { state, setStateCustom, setState, setLoad } = VariableExpenses();

  const Submit = (e) => {
    e.preventDefault();
    dispatch(exportExpenses(state, setLoad, statement_id));
  };

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: `popupR`,
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div
        className={`div_popup ${mode === "dark" ? "darkPopUp" : "lightPopUp"}`}
      >
        <div
          className={`div_title_popup ${
            mode === "dark" ? "darktoppopup" : "lighttoppopup"
          }`}
        >
          <p
            className={`title_popup ${
              mode === "dark" ? "darktext" : "lighttext"
            }`}
          >
            {translate("export_expenses")}
          </p>
        </div>
      </div>
    </RModal>
  );
}

export default ExportExpenses;
